module.exports = __webpack_public_path__ + "static/media/chat_boot.cf50eafb.png";